import { render, staticRenderFns } from "./create-sub-category.vue?vue&type=template&id=4df8bfe9&"
import script from "./create-sub-category.vue?vue&type=script&lang=js&"
export * from "./create-sub-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports